import React, { FC } from 'react';
import produce from 'immer';
import { merge } from 'lodash';
import { useTranslation } from 'react-i18next';

import FormDrawer from '~/components/FormDrawer';
import { ApplicationPayload } from '~/types/ApplicationPayload';

import buildNamePath from '~/utils/buildNamePath';
import { Shareholders } from '~/types/Shareholders';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import BusinessForm, { formName } from './BusinessForm';
import { shareholdersKey } from '.';

interface Props extends Partial<FormItemInjectedProps<Shareholders>> {
  uid: string;
  onClose: () => void;
}

const BusinessEdit: FC<Props> = (props) => {
  const { value, onChange } = props as FormItemInjectedProps<Shareholders>;
  const shareholdersFormState = { shareholders: value };
  const { uid, onClose } = props;

  const { t } = useTranslation('fillApplication');

  const currentIndex =
    shareholdersFormState.shareholders?.businesses?.findIndex((item) => item?.data?.uid === uid) ||
    0;

  const onFinish = (newValues: ApplicationPayload) => {
    const updatedData = produce(shareholdersFormState, (draft) => {
      merge(draft, newValues);
    });
    onChange?.(updatedData.shareholders);
    onClose();
  };

  return (
    <FormDrawer
      id="businessEditDrawer"
      visible={!!uid}
      onClose={onClose}
      title={t('Edit Legal Entity shareholder')}
      formName={formName}
    >
      <BusinessForm
        onFinish={onFinish}
        n={buildNamePath([shareholdersKey, 'businesses', currentIndex])}
        initialValues={shareholdersFormState}
      />
    </FormDrawer>
  );
};

export default BusinessEdit;
